// Deep links between the carta and the inventory pages (Productos, Stock).

export type ProductKind = 'drink' | 'food';

/** Productos page, preselecting the Local and the drinks/foods tab when known. */
export function productsUrl(localId?: number | null, kind?: ProductKind): string {
  const params = new URLSearchParams();
  if (localId) params.set('local', String(localId));
  if (kind) params.set('tab', kind === 'drink' ? 'drinks' : 'foods');
  const query = params.toString();
  return query ? `/products?${query}` : '/products';
}

/** Stock page scrolled to (and highlighting) one product of a Local. */
export function warehouseProductUrl(localId: number, productId: number): string {
  return `/warehouse?local=${localId}&product=${productId}`;
}
